module.exports = __webpack_public_path__ + "img/组 1472@2x.613ecc69.png";